import { PROMOS_AND_REWARDS_CONSTANT } from '../Constants/PromosRewardsConstant';
import parse from 'html-react-parser';
import { jsonParsed, ParseJsonSafely } from 'common/utilities/utils';
import { getUnixTimeInSeconds, getCurrentDateTime, getTimeDifference } from 'common/utilities/dayJsUtils';

const { URL, PNG } = PROMOS_AND_REWARDS_CONSTANT;

export const getFinalContentData = (isLoggedIn, contentData, isApplicableAPILoading) => {
  const finalContentData = [...contentData];
  !isApplicableAPILoading &&
    !contentData.length &&
    finalContentData.push({
      cardType: 'empty',
    });

  !isLoggedIn &&
    finalContentData.push({
      cardType: 'login',
    });
  return finalContentData;
};

const getKey = key => {
  return `${String(key).substr(0, 1).toLowerCase()}${String(key).substr(1)}`;
};

export const jsontoObjects = obj => {
  return (
    obj?.length &&
    obj.reduce(
      (acc, { key, value }) =>
        (acc = {
          ...acc,
          [getKey(key)]:
            String(value).toUpperCase() === 'TRUE'
              ? true
              : String(value).toUpperCase() === 'FALSE'
              ? false
              : jsonParsed(value),
        }),
      {},
    )
  );
};

/**
 * Converts Terms and Conditions array into mappable Array of Objects
 * @param {Array} conditions
 * @returns {Array}
 */
export const getConditions = conditions => {
  return conditions
    ?.map(msg => ({
      displayOrder: msg.displayOrder,
      message: msg.displayMessage[0]?.value,
      parameter: convertIntoObj(msg?.parameter),
    }))
    .sort((a, b) => +a.displayOrder - +b.displayOrder);
};

const getCustomProperties = (customProperties, key, customAttributesCulture) => {
  let resHeader = '';
  if (customAttributesCulture) {
    customAttributesCulture.forEach(custPrp => {
      if (custPrp.attribute === key) {
        resHeader = custPrp?.value[0]?.value;
      }
    });
  } else {
    customProperties.forEach(custPrp => {
      if (custPrp.key === key) {
        resHeader = custPrp.value;
      }
    });
  }
  return resHeader;
};

/**
 * converts strings into object*/
const convertIntoObj = str => {
  let parameter = jsonParsed(String(str));
  if (typeof parameter == 'string') {
    parameter = {};
    parameter['value'] = str?.replace(/[^a-zA-Z0-9]/g, '');
  }
  return str;
};

/**
 * converts strings with html elemnts into react elements
 * @param {String} heading
 * @returns {JSX.Element} JSX Element
 */
export const getMarkedHeading = (heading = '') => {
  const alteredHeading = heading?.replace('<strikethrough>', '<del>').replace('</strikethrough>', '</del>');
  return parse(`${alteredHeading}`);
};

/**
 calculate inline width and margin for red ribbon 
 */
export const calculateInlineWidth = headerText => {
  const marginScallingFactor = 5;
  const header = '' + headerText;
  const _left = header?.length > 10 ? marginScallingFactor - header?.length / marginScallingFactor + 'px' : '5px';
  return {
    'margin-left': _left,
  };
};
export const truncate = str => {
  return str.length > 25 ? str.substring(0, 22) + '...' : str;
};
const getPromoParams = promotionDetails => {
  const conditions = promotionDetails?.conditions?.filter(item => item?.name === 'IsItemExist');
  return conditions?.length
    ? conditions?.map(item => ParseJsonSafely(item?.parameter ?? '{}')?.items).reduce((pre, curr) => pre?.concat(curr))
    : [];
};

export const modifyOffersData = (data, tenantData) =>
  data.map(coupon => ({
    couponCode: coupon?.code,
    titleValue:
      coupon?.promotionDetails?.title &&
      coupon?.promotionDetails?.title.length &&
      getMarkedHeading(coupon?.promotionDetails?.title[0]?.value),
    smallText:
      coupon?.promotionDetails?.description &&
      coupon?.promotionDetails?.description.length &&
      coupon?.promotionDetails?.description[0]?.value,
    imageSrc:
      coupon?.promotionDetails?.image &&
      coupon?.promotionDetails?.image.length &&
      URL + coupon?.promotionDetails?.image[0]?.value + PNG,
    imageName:
      coupon?.promotionDetails?.image?.length &&
      coupon?.promotionDetails?.image[0]?.value + PNG + `?ver=` + tenantData?.imageVersion,
    validityEndTime: coupon?.endDateTime,
    termsAndConditions: getConditions(coupon?.promotionDetails?.conditions),
    isApplicable: coupon?.isApplicable,
    isApplied: coupon?.isApplied,
    itemDetails: coupon?.itemDetails,
    isRewards: coupon?.isRewards,
    cardType: coupon?.promotionDetails?.cardType,
    header: getCustomProperties(
      coupon?.promotionDetails?.customProperties,
      'header',
      coupon?.promotionDetails?.customAttributesCulture,
    ),
    hideEndDate: getCustomProperties(
      coupon?.promotionDetails?.customProperties,
      'hideEndDate',
      coupon?.promotionDetails?.customAttributesCulture,
    ),
    legalText: getCustomProperties(
      coupon?.promotionDetails?.customProperties,
      'legalText',
      coupon?.promotionDetails?.customAttributesCulture,
    ),
    showTimer: getCustomProperties(
      coupon?.promotionDetails?.customProperties,
      'showTimer',
      coupon?.promotionDetails?.customAttributesCulture,
    ),
    promoParameters: getPromoParams(coupon?.promotionDetails),
    ...jsontoObjects(
      coupon?.promotionDetails?.customAttributesCulture
        ? coupon?.promotionDetails?.customAttributesCulture
        : coupon?.promotionDetails?.customProperties,
    ),
  }));

/**
 *
 * @param {number} time
 * @returns {boolean} isPastTime
 */
export const isTimeValid = time => {
  if (time) {
    const endTime = getUnixTimeInSeconds(time);
    const currTime = getCurrentDateTime();
    const secDiff = getTimeDifference(endTime, currTime, 'seconds');
    const isPastTime = String(secDiff).includes('-');
    return endTime.isValid() && !isPastTime;
  } else {
    return false;
  }
};

/**
 * Method to find the time to expiry of coupon and
 * creating time string in format ({HH}HR : {MM}M : {SS}S)
 * @param {Number} time - Time in Unix format
 * @returns {String}
 */
export const getTimeString = time => {
  const endTime = getUnixTimeInSeconds(time);
  const currTime = getCurrentDateTime();
  const hourDiff = getTimeDifference(endTime, currTime, 'hour');
  const addedHour = currTime.add(hourDiff, 'hours');
  const minDiff = getTimeDifference(endTime, addedHour, 'minute');
  const addedMinute = addedHour.add(minDiff, 'minutes');
  const secDiff = getTimeDifference(endTime, addedMinute, 'second');
  return `${hourDiff}HR : ${minDiff}M : ${secDiff}S`;
};
